import { FirebaseOptions, initializeApp } from 'firebase/app'
// prettier-ignore
import { Firestore, initializeFirestore, memoryLocalCache, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore'
import { getStorage, FirebaseStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage'
import { initializeAuth, browserLocalPersistence, GoogleAuthProvider, Auth } from 'firebase/auth'

export const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENTID
}

let _fireBaseBackend: Firestore = null
let _fireStore: Firestore = null
let _fireBaseStorage: FirebaseStorage = null
let _auth: Auth = null
let provider = null

function initFirebaseBackend() {
  const app = initializeApp(firebaseConfig)

  if (!_fireStore) {
    const cap = (window as any).Capacitor
    const isNative = cap != null && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform()

    if (isNative) {
      _fireStore = initializeFirestore(app, {
        localCache: memoryLocalCache(),
        experimentalForceLongPolling: true
      })
    } else {
      _fireStore = initializeFirestore(app, {
        localCache: persistentLocalCache({
          tabManager: persistentMultipleTabManager(),
          cacheSizeBytes: 50 * 1024 * 1024
        })
      })
    }
  }

  // TODO: remove this - mantém compatibilidade com código legado
  if (!_fireBaseBackend) {
    _fireBaseBackend = _fireStore
  }

  if (!_fireBaseStorage) {
    _fireBaseStorage = getStorage(app)
  }

  if (!_auth) {
    _auth = initializeAuth(app, {
      persistence: browserLocalPersistence
    })
  }

  if (!provider) {
    provider = new GoogleAuthProvider()
  }
}

function getFirebaseBackend() {
  return _fireBaseBackend
}

export {
  getFirebaseBackend,
  initFirebaseBackend,
  _fireBaseStorage,
  _fireStore,
  _auth,
  provider,
  _fireBaseBackend as db
}

type UploadResult = {
  url: string
  fileType: string
  fileName: string
  filePath: string
}

export async function uploadFile(file: File): Promise<UploadResult> {
  // Usa a instância singleton ao invés de criar nova
  if (!_fireBaseStorage) {
    throw new Error('Firebase Storage não inicializado. Execute initFirebaseBackend() primeiro.')
  }

  const filePath = `uploads/quick-replies/${Date.now()}_${file.name}`
  const fileRef = ref(_fireBaseStorage, filePath)

  const snapshot = await uploadBytes(fileRef, file)
  const url = await getDownloadURL(snapshot.ref)

  return {
    url,
    fileType: file.type,
    fileName: file.name,
    filePath
  }
}

export async function deleteFile(filePath: string): Promise<void> {
  // Usa a instância singleton ao invés de criar nova
  if (!_fireBaseStorage) {
    throw new Error('Firebase Storage não inicializado. Execute initFirebaseBackend() primeiro.')
  }

  const fileRef = ref(_fireBaseStorage, filePath)
  await deleteObject(fileRef)
}
